import {ViewerSettings} from "../redux_constants/viewerSettings.constant";

/**
 * @deprecated: [Priyanshu] viewerSettings is replaced by displaySettings
 * */
export const showSeenAreaChanged = () => ({
	type: ViewerSettings.SHOW_SEEN_AREA_CHANGED,
});


